import coreCMS from 'assets/core/js/entry/cms'
import lastSeen from 'assets/core/js/module/lastSeen'
import dataLayer from 'assets/core/js/page/search/dataLayer'
import productFavorite from 'assets/core/js/page/search/product/favorite'
import searchForm from 'assets/themes/campings/js/module/searchForm'
import blocksToggle from 'assets/themes/campings/js/page/search/blocksToggle'
import bookingReward from 'assets/themes/campings/js/page/search/bookingReward'
import budgetSlider from 'assets/themes/campings/js/page/search/budgetSlider'
import crossBorder from 'assets/themes/campings/js/page/search/cross-border'
import filters from 'assets/themes/campings/js/page/search/filters'
import imagesSliders from 'assets/themes/campings/js/page/search/imagesSliders'
import loading from 'assets/themes/campings/js/page/search/loading'
import map from 'assets/themes/campings/js/page/search/map'
import openProductPageLinks from 'assets/themes/campings/js/page/search/openProductPageLinks'
import results from 'assets/themes/campings/js/page/search/results'
import sorting from 'assets/themes/campings/js/page/search/sorting'

document.addEventListener('DOMContentLoaded', function () {
  dataLayer()
  imagesSliders.init()

  budgetSlider()
  openProductPageLinks()
  sorting()
  blocksToggle()
  loading()
  filters()
  map()
  productFavorite()
  bookingReward()
  searchForm()

  coreCMS()
  results()
  lastSeen()
  crossBorder()
})
